
import { Vue, Component, Prop } from "vue-property-decorator";

import {EventBus} from "@common/EventBus";
import { createPopper, Instance as PopperInstance, Modifier, OptionsGeneric, Placement } from "@popperjs/core";

@Component({})

export default class UsersListItemBase extends Vue {
    @Prop({ default: true }) needOpenChat: boolean;
    @Prop({ default: "top-start" }) placement: Placement;
    @Prop({default: true}) needPopup: boolean;


    popper: PopperInstance | null = null;
    showPopup = false;
    closed = true;

    renderPopup() {

        if(!this.needPopup) {
            return
        }

        this.showPopup = true;

        const children = this.$el.children;

        this.$nextTick(() => {
            const $reference = children.namedItem('user-block');
            const $tooltip = children.namedItem('tooltip') as HTMLElement | null;

            if($reference && $tooltip) {
                const options: Partial<OptionsGeneric<Partial<Modifier<"offset" | "arrow", any>>>> = {
                    placement: this.placement,
                    modifiers: [
                        {
                            name: "offset",
                            options: {
                                offset: [0, 0]
                            }
                        }
                    ]
                }

                this.popper = createPopper(
                    $reference,
                    $tooltip,
                    options
                )
            }
            else {
                throw new Error("$reference or $tooltip is not defined")
            }
        });

        this.closed = false;
        const timer = setInterval(() => {
            if(this.closed) {

                this.showPopup = false;
                clearInterval(timer);
            }
        }, 2000)
    }

    async openChat(userId: number | undefined) {
        if(this.needOpenChat && userId) {
            EventBus.$emit("showChatByUserId", userId)
        }
    }

    leave() {
        if(!this.needPopup) {
            return
        }

        this.closed = true;
    }
}